<div [formGroup]="form" class="flex flex-col items-stretch mt-0 mr-0 ml-0">
	<div class="mb-3 flex flex-col items-stretch mt-0 mr-0 ml-0">
		<label>{{ BASE_I18N_KEY + '.lastName.label' | translate }}*</label>
		<input formControlName="lastName" pInputText />
	</div>
	<div class="mb-3 flex flex-col items-stretch mt-0 mr-0 ml-0">
		<label>{{ BASE_I18N_KEY + '.firstName.label' | translate }}*</label>
		<input formControlName="firstName" pInputText />
	</div>
	<div class="mb-3 flex flex-col items-stretch mt-0 mr-0 ml-0">
		<label>{{ BASE_I18N_KEY + '.emailAddress.label' | translate }}*</label>
		<input formControlName="emailAddress" pInputText />
	</div>
	<div class="mb-3 flex flex-col items-stretch mt-0 mr-0 ml-0">
		<label>{{ BASE_I18N_KEY + '.organization.label' | translate }}*</label>
		<p-dropdown
			[options]="organizationOptions$ | async"
			[style]="{ width: '100%' }"
			appendTo="body"
			formControlName="organizationId"
		></p-dropdown>
	</div>
	<div class="mb-3 flex flex-col items-stretch mt-0 mr-0 ml-0">
		<label>{{ BASE_I18N_KEY + '.language.label' | translate }}</label>
		<p-dropdown
			[options]="languageOptions$ | async"
			[style]="{ width: '100%' }"
			appendTo="body"
			formControlName="language"
		></p-dropdown>
	</div>
	<div class="mb-3 flex flex-col items-stretch mt-0 mr-0 ml-0">
		<label>{{ BASE_I18N_KEY + '.welcomeMessage.label' | translate }}</label>
		<textarea formControlName="welcomeMessage" pInputTextarea></textarea>
	</div>
	<button
		[disabled]="!(formValid$ | async)"
		[label]="BASE_I18N_KEY + '.add.label' | translate"
		(click)="onAddClick()"
		pButton
	></button>
</div>
